import { Box, Heading, ListItem, UnorderedList } from "@chakra-ui/react";
import React from "react";

const ThinqueLegend = () => {
  return (
    <Box
      height={"69vh"}
      overflow={"auto"}
      boxShadow={"rgba(0, 0, 0, 0.24) 0px 3px 8px"}
      padding={5}
    >
      <Heading fontSize={22}>Power</Heading>
      <UnorderedList fontSize="md" spacing={4} pl={4} pt={4}>
        <ListItem>
          BNZE (%) – This represents the site or accumulated sites
          Building Net Zero Energy status. It is measured as a percentage (%)
          against your grid and solar usage (Refer GHG Avoided for solar value).
        </ListItem>
        <ListItem>
          Total Consumption (kWh) - Total consumption is calculated. It is
          calculated as follows: consumption + solar = total consumption. LOAD +
          solar: Total consumption is directly measured by the consumption
          clamps and does not interact with solar production.
        </ListItem>
        <ListItem>
          Solar Electricity Consumed (kWh) – This represents the total amount of
          solar used on the site
        </ListItem>
        <ListItem>
          Solar Exported to Grid (kWh) – this is the excess solar sent back to
          the grid.
        </ListItem>
        <ListItem>
          GHG Emissions – (CO2) These are calculated against the grid power
          based off the DCCEW GHG Settings annually by the Australian Federal
          Government
        </ListItem>
        <ListItem>
          GHG Avoided (CO2) – This is calculated against any site renewables
          that interact with the site’s electricity requirements. This is
          calculated at 100% reduction &amp; carbon neutrality after 3 years to
          offset their production and manufacture.{" "}
          <b>
            Solar panels when newly installed are calculated to emit 50 grams of
            C02 per kilowatt per year until the end of the third year based off
            their manufacture.
          </b>
        </ListItem>
        <ListItem>
          Harmonics - (Additional Fees May Apply)
        </ListItem>
        <ListItem>
          Power Factor
        </ListItem>
      </UnorderedList>

      <Heading fontSize={22} pt={4}>
        Utilities
      </Heading>
      <UnorderedList fontSize="md" spacing={4} pl={4} pt={4}>
        <ListItem>
          Water (KL) – This is measured monthly in Kilolitres or Megalitres
        </ListItem>
        <ListItem>Gas (KJ) – Coming Soon</ListItem>
        <ListItem>
          Gas (CO2) – GHG calculation based off gas CO2 values from the DCCEW
          calculations per tonne.
        </ListItem>
        <ListItem>Fuel (KL) – Coming Soon</ListItem>
        <ListItem>
          Fuel (CO2) - GHG calculation based off gas CO2 values from the DCCEW
          calculations
        </ListItem>
      </UnorderedList>

      <Heading fontSize={22} pt={4}>
        Environmental (IAQ)
      </Heading>
      <UnorderedList fontSize="md" spacing={4} pl={4} pt={4}>
        <ListItem>CO2 – Carbon Dioxide</ListItem>
        <ListItem>
          PM2.5 – Particulate Matter at 2.5U or lower measure six different air
          pollutants
        </ListItem>
        <ListItem>TVOC – Total Volatile Organic Compounds</ListItem>
        <ListItem>Indoor Temperature - Site specific to the location</ListItem>
        <ListItem>Indoor Humidity – Site Specific to the location</ListItem>
        <ListItem>Outdoor Temperature</ListItem>
        <ListItem>Outdoor Humidity</ListItem>
      </UnorderedList>

      <Heading fontSize={22} pt={4}>
        Ancillary
      </Heading>
      <UnorderedList fontSize="md" spacing={4} pl={4} pt={4}>
        <ListItem>Electric Vehicles</ListItem>
        <ListItem>Refrigeration</ListItem>
        <ListItem>Air Conditioning</ListItem>
        <ListItem>Pumps</ListItem>
      </UnorderedList>
    </Box>
  );
};

export default ThinqueLegend;
